<footer class="modern-footer" style="background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%); border-top: 4px solid #1f981f;">
  <div class="container py-5">
    <!-- Main Footer Content -->
    <div class="row g-4">
      <!-- Company Info Section -->
      <div class="col-lg-3 col-md-6">
        <div class="footer-section">
          <a routerLink="/" class="footer-logo d-block mb-3">
            <img src="assets/befret_logo.png" alt="Logo BeFret" class="img-fluid" style="max-height: 60px;">
          </a>
          <p class="footer-tagline text-muted mb-3">
            <strong style="color: #1f981f;">{{ "NAVIGATION.FOOTER.SEND_FROM_HOME" | productionTranslate }}</strong>
          </p>
          <div class="footer-social">
            <h6 class="footer-social-title mb-3" style="color: #1f981f; font-weight: 600;">{{ "NAVIGATION.FOOTER.FOLLOW_US" | productionTranslate }}</h6>
            <div class="social-links">
              <a [href]="facebookUrl" target="_blank" rel="noopener noreferrer" class="social-link" aria-label="Facebook" data-testid="footer-facebook">
                <i class="fab fa-facebook-f"></i>
              </a>
              <a [href]="instagramUrl" target="_blank" rel="noopener noreferrer" class="social-link" aria-label="Instagram" data-testid="footer-instagram">
                <i class="fab fa-instagram"></i>
              </a>
              <a href="https://www.tiktok.com/@befret.be?_t=ZG-901Pr237qaX&_r=1" target="_blank" class="social-link" aria-label="TikTok">
                <i class="fab fa-tiktok"></i>
              </a>
              <a href="https://wa.me/32473282139" target="_blank" class="social-link" aria-label="WhatsApp">
                <i class="fab fa-whatsapp"></i>
              </a>
            </div>
          </div>
        </div>
      </div>

      <!-- Support Section -->
      <div class="col-lg-3 col-md-6">
        <div class="footer-section">
          <h6 class="footer-title" style="color: #1f981f; font-weight: 600; margin-bottom: 1rem;">{{ "NAVIGATION.FOOTER.CUSTOMER_SUPPORT" | productionTranslate }}</h6>
          <ul class="footer-links list-unstyled">
            <li class="mb-2">
              <a [href]="'tel:' + supportPhoneTel" class="footer-link">
                <i class="fa fa-phone me-2" style="color: #1f981f;"></i>
                {{ supportPhone }}
              </a>
            </li>
            <li class="mb-2">
              <a [href]="'mailto:' + supportEmail" class="footer-link">
                <i class="far fa-envelope me-2" style="color: #1f981f;"></i>
                {{ supportEmail }}
              </a>
            </li>
            <li class="mb-2">
              <a routerLink="/faq" class="footer-link">
                {{ "NAVIGATION.FOOTER.FAQ" | productionTranslate }}
              </a>
            </li>
          </ul>
        </div>
      </div>

      <!-- Legal Section -->
      <div class="col-lg-3 col-md-6">
        <div class="footer-section">
          <h6 class="footer-title" style="color: #1f981f; font-weight: 600; margin-bottom: 1rem;">{{ "NAVIGATION.FOOTER.LEGAL_INFO" | productionTranslate }}</h6>
          <ul class="footer-links list-unstyled">
            <li class="mb-2">
              <a routerLink="/legal" class="footer-link">
                {{ "NAVIGATION.FOOTER.LEGAL_MENTIONS" | productionTranslate }}
              </a>
            </li>
            <li class="mb-2">
              <a routerLink="/privacy" class="footer-link">
                {{ "NAVIGATION.FOOTER.PRIVACY_NOTICE" | productionTranslate }}
              </a>
            </li>
            <li class="mb-2">
              <a routerLink="/conditions" class="footer-link">
                {{ "NAVIGATION.FOOTER.TERMS_CONDITIONS" | productionTranslate }}
              </a>
            </li>
            <li class="mb-2">
              <a routerLink="/cookies" class="footer-link">
                {{ "NAVIGATION.FOOTER.COOKIE_SETTINGS" | productionTranslate }}
              </a>
            </li>
          </ul>
        </div>
      </div>

      <!-- Security & Help Section -->
      <div class="col-lg-3 col-md-6">
        <div class="footer-section">
          <h6 class="footer-title" style="color: #1f981f; font-weight: 600; margin-bottom: 1rem;">{{ "NAVIGATION.FOOTER.SECURITY_HELP" | productionTranslate }}</h6>
          <ul class="footer-links list-unstyled">
            <li class="mb-2">
              <a routerLink="/fraud" class="footer-link">
                {{ "NAVIGATION.FOOTER.FRAUD_AWARENESS" | productionTranslate }}
              </a>
            </li>
            <li class="mb-2">
              <a routerLink="/litiges" class="footer-link">
                {{ "NAVIGATION.FOOTER.DISPUTE_RESOLUTION" | productionTranslate }}
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <!-- Divider -->
    <hr class="footer-divider my-4" style="border-color: #1f981f; opacity: 0.2;">

    <!-- Scroll to Top Button -->
    <div class="scroll-top-container text-center mb-3">
      <button (click)="scrollToTop(); $event.preventDefault()" class="scroll-top-btn" [title]="'COMMON.NAVIGATION.SCROLL_TO_TOP' | productionTranslate" type="button">
        <i class="fa fa-chevron-up"></i>
      </button>
    </div>
  </div>

  <!-- Bottom Copyright Bar -->
  <div class="footer-bottom" style="background-color: #1f981f; color: white;">
    <div class="container py-3">
      <div class="row align-items-center">
        <div class="col-md-6 text-center text-md-start">
          <span class="copyright-text">Copyright® BeFret</span>
          <span class="version-tag">v{{ appVersion.version }}</span>
          <span class="employee-link-separator">|</span>
          <a routerLink="/backoffice-login" class="employee-portal-link">
            <i class="fas fa-lock"></i> {{ 'COMMON.NAVIGATION.EMPLOYEE_AREA' | productionTranslate }}
          </a>
        </div>
        <div class="col-md-6 text-center text-md-end">
          <div class="language-selector">
            <button
              type="button"
              class="lang-link"
              [class.active]="currentLanguage === 'nl'"
              (click)="setLanguage('nl')"
              title="Nederlands (BE)"
            >
              Nederlands
            </button>
            <span class="lang-separator">|</span>
            <button
              type="button"
              class="lang-link"
              [class.active]="currentLanguage === 'en'"
              (click)="setLanguage('en')"
              title="English (UK)"
            >
              English
            </button>
            <span class="lang-separator">|</span>
            <button
              type="button"
              class="lang-link"
              [class.active]="currentLanguage === 'fr'"
              (click)="setLanguage('fr')"
              title="Français"
            >
              Français
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</footer>